import React from 'react';
import { useDispatch } from 'react-redux';
import RegisterForm from '../../../../components/app_common/register_form';
import RegisterActions from '../../../../redux/reducers/register_reducer/actions';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';

export default function AddApplicant() {
  const dispatch = useDispatch();
  const ROLE = AuthSelectors.useSelectUserRole();
  React.useEffect(() => {
    dispatch(RegisterActions.fetchSchemeTypesAction());
    // dispatch(Authentication)
  }, [dispatch]);

  return <RegisterForm isAddApplicantPage={true} role={ROLE} />;
}
